/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IOktoberfestData, IReplayNextPlayerInteraction} from "./IOktoberfestData";
import {OktoberfestDataParser} from "./OktoberfestDataParser";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {resolveSrv} from "dns";

export abstract class OktoberfestParsedData {

    public readonly mode:string;
    public readonly nextMode:string;
    public readonly reels:string[][];
    public readonly nextReelSetName:string;
    public readonly totalWin:number;
    public readonly currentMultiplier:number;
    public readonly scatterPositions:number[] | undefined;
    public readonly freespinsLeft:number;
    public readonly freespinTriggeredThisSpin:boolean;
    public readonly addedNumberOfFreespinsThisSpin:number;
    public readonly numberOfFreespinsPlayed:number;
    public readonly replayNextPlayerInteraction:IReplayNextPlayerInteraction | undefined;
    public readonly showTotalWin:boolean;

    // To add Avalanche Data
    // public readonly allWinPositions:boolean[][];
    // public readonly reelsAfterCollapse:string[][];


    constructor(rawData:IOktoberfestData, parser:OktoberfestDataParser) {
        this.mode = rawData.mode;
        this.nextMode = rawData.nextMode;
        this.reels = parser.parseReels(rawData);
        this.nextReelSetName = rawData.reelsNextSpin;
        this.totalWin = rawData.accumulatedRoundWin != null ? parseFloat(rawData.accumulatedRoundWin) : 0;
        this.currentMultiplier = rawData.currentMultiplier != null ? rawData.currentMultiplier : 1;
        this.scatterPositions = this.parseScatterPositions(rawData);

        this.freespinsLeft = rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
        this.freespinTriggeredThisSpin = rawData.freespinTriggeredThisSpin === true;
        this.addedNumberOfFreespinsThisSpin = rawData.addedNumberOfFreespinsThisSpin != null ? rawData.addedNumberOfFreespinsThisSpin : 0;
        this.numberOfFreespinsPlayed = rawData.numberOfFreespinsPlayed != null ? rawData.numberOfFreespinsPlayed : 0;
        this.replayNextPlayerInteraction = SlotGame.apiPlugin.isReplay ? rawData.nextPlayerInteraction : undefined;
        this.showTotalWin = this.parseShowTotalWin();

    }

    protected parseShowTotalWin():boolean {
        return this.isRespinMode(this.mode) || this.isRespinMode(this.nextMode) ||
            this.isFreespinMode(this.mode) || this.isFreespinMode(this.nextMode)

    }

    private isRespinMode(mode:string):boolean {
        return mode === GameMode.RESPIN || mode==="WILD_RESPIN";  // || mode === GameMode.NORMAL_AVALANCHE || mode === GameMode.FREESPIN_AVALANCHE
    }

    private isFreespinMode(mode:string):boolean {
        return this.freespinTriggeredThisSpin || mode === GameMode.FREESPIN; // || mode === TombstoneGameMode.SUPER_FREESPIN || pick
    }

    protected abstract parseScatterPositions(rawData:IOktoberfestData):number[] | undefined;

}